export default __webpack_public_path__ + "static/logo-white-75349e045823595563fe79bd1cbed02f.png";